import '../styles/search-box.scss';
import React, { useEffect, useRef } from "react";


export function SearchBox({ onSearchChange, searching, minLength }) {
    let sync = useRef({}).current;

    useEffect(() => {
        if (!searching) {
            let trimmed = (sync.text || "").trim();
            if (trimmed !== sync.lastSearch)
                doSearch(trimmed);
        }
    }, [searching]);

    function onChange(e) {
        let text = e.currentTarget.value;
        let trimmed = text.trim();
        let prevTrimmed = (sync.text || "").trim();
        let shouldSearch = !searching && (!minLength || trimmed.length >= minLength || prevTrimmed.length >= minLength); // Must be at least minLength or have a previous search

        sync.text = text;
        if (shouldSearch && trimmed !== sync.lastSearch)
            doSearch(trimmed);
    }

    function doSearch(text) {
        sync.lastSearch = text;
        onSearchChange(text);
    }

    return (
        <label className="search-box">
            <i className="fal fa-search"></i>
            <input name="search" placeholder="Search" onChange={onChange} data-qa="search" />
        </label>
    );
}

